import React, { useEffect, useRef, useState } from "react";

import {
  Box,
  Button,
  InputLabel,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import ZoomableImage from "./zoomableImage";
import CustomButton from "../../reusableComponents/CustomButton";
const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const contentStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignItems: "flex-start",
  textAlign: "left",
  height: "400px",
  width: "416px",
};

function CropImage({ openCrop, onClose, onCloseCrop, data, setSelectedImage }) {
  const [crop, setCrop] = useState({
    unit: "px", // Can be 'px' or '%'
    x: 112.5,
    y: 50,
    width: 150,
    height: 150,
    aspect: 1,
  });

  const [output, setOutput] = useState(null);
  const [scale, setScale] = useState(1);
  const applyCrop = () => {
    if (crop.width && crop.height) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const image = new Image();
      image.src = data; // Replace with your original image URL
      // Set canvas dimensions
      canvas.width = crop.width;
      canvas.height = crop.height;

      // Draw the cropped region on the canvas
      ctx.drawImage(
        image,
        crop.x -
        (375 - image.naturalWidth) / 2 +
        ((scale - 1) * image.naturalWidth) / 2,
        crop.y -
        (250 - image.naturalHeight) / 2 +
        ((scale - 1) * image.naturalHeight) / 2,
        crop.width / scale,
        crop.height / scale,
        0,
        0,
        crop.width,
        crop.height
      );

      // Convert the canvas content to a data URL (Base64)
      const croppedImageUrl = canvas.toDataURL("image/png"); // You can choose another format if needed
      setSelectedImage(croppedImageUrl);
      onCloseCrop();
    }
  };
  const handleCancel = () => {
    setSelectedImage("");
    onCloseCrop();
  };
  const handleCross = () => {
    setSelectedImage("");
    onClose();
    onCloseCrop();
  };
  return (
    <Modal
      open={openCrop}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={modalStyle}
    >
      <Box sx={contentStyle}>
        <div style={{ display: "flex" }}>
          <Typography style={{ fontSize: "17px" }} variant="h5">
            Crop Logo{" "}
          </Typography>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            marginTop: "-20px",
          }}
        >
          <img
            src="/assets/close-modal-cross.svg"
            style={{ height: "20px", width: "20px" }}
            onClick={handleCross}
          />
        </div>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            alignSelf: "center",
            paddingTop: "15px",
          }}
        >
          <ZoomableImage
            src={data}
            crop={crop}
            setCrop={setCrop}
            scale={scale}
            setScale={setScale}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            width: "100%",
            marginTop: "28px",
          }}
        >
          <div style={{ paddingRight: "20px" }}>
            <CustomButton
              text={"Cancel"}
              type={"secondary"}
              size={"sm"}
              onClick={handleCancel}
            />
          </div>
          <CustomButton
            text={"Crop"}
            type={"secondary"}
            size={"sm"}
            variant={"contained"}
            onClick={applyCrop}
          />
        </div>
      </Box>
    </Modal>
  );
}

export default CropImage;
